<template>
  <div>
    <el-dialog class="registe-dialog"
               :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="70%">
      <el-form :model="dataForm"
               :rules="dataRule"
               label-position="left"
               class="assessmentAddUser-add-form">
        <el-row>
          <!-- 姓名 -->
          <el-col :span="6">
            <el-form-item :label="$t('user.name')">
              <el-input v-model="dataForm.userName"
                        clearable
                        :placeholder="$t('user.select')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item :label="$t('assessment.currentPositionName')">
              <el-select v-model="dataForm.positionCode"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="queryPosition">
                <el-option v-for="item in results"
                           :key="item.positionCode"
                           :label="item.positionInfo"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button style="margin-bottom: 7px"
                         class="M-search"
                         type="primary"
                         @click="query()">{{ $t('query') }}
              </el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="resetFrom()">{{ $t('reset') }}
              </el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div class="search" style="margin-bottom:20px">
        <!-- 添加用户 -->
        <el-button type="primary"
                   @click="addUser()"
                   :disabled="disabled">{{ $t('assessment.addUser') }}
        </el-button>
      </div>
      <!-- 表格 -->
      <div class="selectRadioClass">
        <el-table v-loading="dataListLoading"
                  :data="dataList"
                  ref="multipleTable"
                  border
                  class="jySelectionAll"
                  @select="handleSelectionChange"
                  style="width: 100%;">
          <!-- 选择框 -->
          <el-table-column type="selection"
                           align="center"
                           fixed="left">
          </el-table-column>
          <!-- 员工ID -->
          <el-table-column prop="userCode"
                           :label="$t('user.userID')"
                           width="150"
                           header-align="center"
                           align="center"></el-table-column>
          <!-- 员工卡号 -->
          <el-table-column prop="userCardNo"
                           :label="$t('user.userCardNo')"
                           width="150"
                           header-align="center"
                           align="center"></el-table-column>
          <!-- 姓名 -->
          <el-table-column prop="userNameCn"
                           :label="$t('user.name')"
                           width="120"
                           header-align="center"
                           align="center"></el-table-column>
          <!-- 证件编号 -->
          <el-table-column prop="cardNo"
                           :label="$t('user.passportIdcard')"
                           width="180"
                           header-align="center"
                           align="center"></el-table-column>
          <!-- 主要职位 -->
          <el-table-column prop="positionName"
                           :label="$t('user.position')"
                           width="160"
                           header-align="center"
                           align="center"></el-table-column>
          <!-- 兼职职位1 -->
          <el-table-column prop="partJobOneName"
                           :label="$t('user.parttimejob1')"
                           width="160"
                           header-align="center"
                           align="center"></el-table-column>
          <!-- 兼职职位2 -->
          <el-table-column prop="partJobTwoName"
                           :label="$t('user.parttimejob2')"
                           width="160"
                           header-align="center"
                           align="center"></el-table-column>
          <!-- 网点类型 -->
          <el-table-column prop="networkType"
                           :label="$t('user.outletType')"
                           width="120"
                           header-align="center"
                           align="center"></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </el-dialog>
    <el-dialog
      :title="$t('prompt.title')"
      :append-to-body="true"
      :modal-append-to-body="false"
      custom-class="user-transfer-islimit-modal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="limitShow"
      :before-close="closeLimitModal"
      :width="isLimit ? '760px' : '420px'">
        <LimitInfoModal v-if="limitShow" :isLimit="isLimit" :factoryDesc="factoryDesc" @closeLimitModal="closeLimitModal" :isAccessApply="isAccessApply"></LimitInfoModal>
    </el-dialog>
  </div>
</template>
<script>
  import LimitInfoModal from '@/views/modules/acdc/limitAccess/limitModal'
  import mixinViewModule from '@/mixins/view-module'
  import debounce from 'lodash/debounce'
  import {moduleRoutes} from '@/router'

  export default {
    components: {
      LimitInfoModal
    },
    mixins: [mixinViewModule],
    // name: 'addUser',
    data() {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/commuser/queryUserForRecruitmentByPage',
          getDataListIsPage: true,
        },
        visible: false,
        dataForm: {
          roleType:''
        },
        // positionArr: [],
        results: [],
        multipleSelection: [], // 多选数组
        jobId: '',
        chooseList: [],
        tabCkeck: '',
        disabled: true,
        limitShow: false,
        isLimit: false,
        factoryDesc: '',
        isAccessApply: true
    }
  },
  created() {
    if (this.$hasPermission('ACDC0000001')) {
      this.dataForm.roleType = 'acdcAdmin'
    }
  },
  methods: {
    init() {
      this.visible = true
      this.disabled = true
      this.dataForm = {
        userName: '',
        positionId: '',
        roleType: this.dataForm.roleType
      }
      this.getDataList()
    },
    query() {
      this.page = 1
      if (this.$hasPermission('ACDC0000001')) {
        this.dataForm.roleType = 'acdcAdmin'
      }
      this.getDataList()
    },
    // 重置
    resetFrom() {
      this.multipleSelection = []
      this.disabled = true
      this.reset()
      if (this.$hasPermission('ACDC0000001')) {
        this.dataForm.roleType = 'acdcAdmin'
      }
      this.getDataList()
    },
    // table Checkbox方法
    handleSelectionChange(selection, row) {
      // 勾选复选框 初始化， 确定按钮不可点击
      //  判断是否有进行中的评估
      //       有
      //         弹框提示(按钮禁止)
      //       无
      //         继续进行， 判断是否有该职位的评估中心记录
      //           有
      //             确定按钮可以点击（取消勾选， 确定按钮不可点击）
      //           无
      //             取消
        this.$refs.multipleTable.clearSelection()
        this.disabled = true // 初始化不能点击
        if (selection.length === 0) { // 判断selection是否有值存在
          return
        }
        if (row) {
          this.$refs.multipleTable.toggleRowSelection(row, true)
          this.multipleSelection = []
          this.multipleSelection.push(row)
          this.isLimitTest(row)
        }
      },
      // 是否限制测评
      isLimitTest(row) {
        this.$request.post(
          '/acdc/restrict/checkRecruitment',
          {
            jobId: this.jobId,
            userId: row.userId
          }
        ).then((res) => {
          if (res) {
            if (res.restrictFlag === true) {
              this.limitShow = true
              this.isLimit = res.restrictFlag
              this.factoryDesc = res.remark
            } else {
              // 再判断是否ongoing
              this.isOngoingRecruitment(row)
            }
          }
        })
      },
      closeLimitModal() {
        this.limitShow = false
        this.factoryDesc = ''
      },
      isOngoingRecruitment(row) {
        this.$request.post(
          '/acdc/recruitment/existOngoingRecruitment',
          {
            jobId: this.jobId,
            orgId: row.orgId,
            userId: row.userId
          }
        ).then((res) => {
          if (res === true) {
            let message = '此用户已有正在进行中的该岗位评估，评估结束前，不可重复提交测评邀请'
            this.$alert(message, this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
          } else {
            this.$request.post(
              '/acdc/recruitment/existEffectiveEvaluation',
              {
                userId: row.userId,
                jobId: this.jobId
              }
            ).then((respons) => {
              if (respons > 0) {
                this.isShowMessage()
              }
              this.disabled = false
            }).catch((err) => {
              console.log(err)
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      // 选择用户弹出框
      isShowMessage() {
        let _this = this
        this.$confirm('此员工已有该职位的评估中心记录。是否再次申请评估？', '提示', {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }).then(() => {
          console.log('确定。。。。')
          this.checkUserOK()
        }).catch(() => {
          console.log('取消啦。。。。。。')
          this.checkUserNO()
        })
      },
      // 选择用户弹出框点击确认触发
      checkUserOK() {
        console.log('选择用户弹出框点击取消触发 ----- ')
      },
      // 选择用户弹出框点击取消触发
      checkUserNO() {
        console.log('选择用户弹出框点击确认触发')
        this.disabled = true // 初始化不能点击
        this.$refs.multipleTable.clearSelection();
      },
      addUser() {
        console.log('addUser')
        console.log(this.multipleSelection)
        if (this.multipleSelection.length === 0) {
          let message = '请选择要添加的用户'
          this.$alert(message, this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
        } else if (this.multipleSelection.length > 1) {
          let message = '一次只能添加一个用户'
          this.$alert(message, this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
        }
        console.log('addUser')
        console.log(this.multipleSelection)
        this.$emit('func', this.multipleSelection)
        this.visible = false
      },
      cellClass(row){
        console.log(row)
        if (row.columnIndex === 0) {
          return 'DisableSelection'
        }
      },
      // 获取职位信息
      queryPosition(queryString) {
        this.$request.get('/sys/commposition/outletPosition',
          {
            name: queryString,
          }
        ).then((res, total, code, data) => {
          this.results = res
          this.results = this.results.map(item => {
            item['value'] = item.positionInfo
            return item
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    computed: {
      dataRule() {
        console.log('dataRule')
      }
    }
  }


</script>
<style lang="scss">
  /* 隐藏网格的全选按钮 */
  .jySelectionAll
  > .el-table__header-wrapper
  > .el-table__header
  > thead
  > tr
  > th
  > .cell
  > label {
    display: none !important;
  }
  .selectRadioClass thead .el-table-column--selection .cell {
    display: none !important;
  }
  .user-transfer-islimit-modal {
    border-radius: 4px !important;
    display: flex;
    flex-direction: column;
    margin:0 !important;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    .el-dialog__header{
      padding: 15px 15px 10px;
    }
    .el-dialog__body {
      padding: 0 !important;
      color: #606266;
      font-size: 14px;
      overflow: hidden;
    }
  }
</style>
